export default function hoverImage() {
    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll(".image-front").forEach(imageFront => {
            const imageBack = imageFront.closest(".image-back");
            if (!imageBack) return;

            imageFront.addEventListener("pointerenter", () => imageBack.classList.add("active"));
            imageFront.addEventListener("pointerleave", () => imageBack.classList.remove("active"));
        });
    });
}